import { render, staticRenderFns } from "./ContentFeedEventTicket.vue?vue&type=template&id=17d3f13f&scoped=true&"
import script from "./ContentFeedEventTicket.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedEventTicket.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedEventTicket.vue?vue&type=style&index=0&id=17d3f13f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d3f13f",
  null
  
)

export default component.exports